import type { SelectedCompanyTile } from "../../../hooks/validationStateSlice.ts";
import { isSmartViewWidget } from "../../../models/isTileObjectSmartView.ts";
import type { DashboardValidationType } from "../../hooks/useDashboardValidation.ts";
import { ArbitraryTileItemValidation, SmartViewTileItemValidation } from "../index.ts";

interface Props {
  tile: SelectedCompanyTile;
  validation: DashboardValidationType;
}

export const TileItemValidation = ({ tile, validation }: Props) => {
  if (isSmartViewWidget(tile.tile.widget)) {
    return <SmartViewTileItemValidation tile={tile} validation={validation} />;
  }
  return <ArbitraryTileItemValidation tile={tile} validation={validation} />;
};
